import * as React from "react";
import HubspotContactForm from "components/modules/HubspotGeneralForm";
import { Dialog } from "@hubble/web";
import type { HubspotModalProps } from "types/commonV1";

const HubspotModal: React.FC<HubspotModalProps> = ({
  modalOpen,
  closeModal,
  formId,
  modalTitle,
  modalSubtitle,
  testId
}) => {
  return (
    <Dialog
      open={modalOpen}
      onOpenChange={(open) => {
        if (!open) {
          closeModal();
        }
      }}
      testId={testId || formId}
    >
      <Dialog.Container>
        <Dialog.Header>
          {modalTitle && <Dialog.Title>{modalTitle}</Dialog.Title>}
          {modalSubtitle && (
            <Dialog.Description>{modalSubtitle}</Dialog.Description>
          )}
        </Dialog.Header>
        <Dialog.Content>
          <HubspotContactForm formId={formId} />
        </Dialog.Content>
      </Dialog.Container>
    </Dialog>
  );
};

export default HubspotModal;
